import { render, staticRenderFns } from "./addReceivingAccountModal.vue?vue&type=template&id=3804d420"
import script from "./addReceivingAccountModal.vue?vue&type=script&lang=js"
export * from "./addReceivingAccountModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports